module.exports = __webpack_public_path__ + "img/trial_expired.ae0edf15.svg";